import { render } from "./MainLayout.vue?vue&type=template&id=455f062e&scoped=true&ts=true&lang=pug"
import script from "./MainLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./MainLayout.vue?vue&type=script&lang=ts&setup=true"

import "./MainLayout.vue?vue&type=style&index=0&id=455f062e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-455f062e"]])

export default __exports__